import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-servicing-request-form-demo',
  templateUrl: 'servicing-request-form.component.html',
  styleUrls: ['servicing-request-form.component.scss']
})
export class ServicingRequestFormComponent_demo implements OnInit {

  @Input() formType: string = 'address'; // What form?

  constructor() { }

  ngOnInit() {
  }

}
